// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"b9f21f59","228":"524f5e04","268":"3b15bc3e","453":"887563e6","471":"c4448870","474":"d6ca1086","962":"f77e2677"}[chunkId] + ".chunk.js";
};